import { calculateCentroid } from "../math/utils";
import { Object3D } from "./object3d";
export class Arrow extends Object3D {
    constructor(p1, p2) {
        super();
        this.p1 = p1;
        this.p2 = p2;
        this.centroid = calculateCentroid([p1, p2]);
    }
}
